import React from 'react';
import ReactDOM from 'react-dom/client';
// Tailwind önce: proje CSS'i utility'leri ezebilsin.
import './styles/tailwind.css';
import './styles/global.css';
import './styles/components/buttons.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './shared/components/feedback/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
